import { render } from "./SelectionWithDetails.vue?vue&type=template&id=0b62e82a"
import script from "./SelectionWithDetails.vue?vue&type=script&lang=js"
export * from "./SelectionWithDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__